import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineActionsDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    }
});

export const useStyles = ({
    controlHeights,
    touchTargets,
    pointerType,
    spaces
}: TimelineActionsDynamicStyleType) => {
    const styles = {
        container: {
            marginTop: spaces.spacingXxs,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(pointerType === "coarse") {
        styles.container.gap = touchTargets.coarse - controlHeights.small;
    }

    return styles;
};
export default stylesheet;
